import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";

import { setContext } from "@apollo/client/link/context";
import apolloClientApi from "./apollo_client_api";
import { getCookie } from "./util/utils";
import { getTeamRequestHeaders } from "./request_headers";


// 创建 HTTP 链接
const httpLink = createHttpLink({
  // 登录弹窗不会刷新页面，因此每次请求都要读取最新的登录 token。
  uri: () => {
    const token = encodeURIComponent(getCookie("mtoken") || "");
    if (/([?&])token=[^&]*/.test(apolloClientApi)) {
      return apolloClientApi.replace(/([?&])token=[^&]*/, `$1token=${token}`);
    }
    const separator = apolloClientApi.includes("?") ? "&" : "?";
    return `${apolloClientApi}${separator}token=${token}`;
  },
});
 
// 使用 setContext 修改请求头
const authLink = setContext(({ variables }, { headers }) => {
  const lang_private_close = sessionStorage.getItem('lang_private_close')
  const lang_private = sessionStorage.getItem("lang_private")
  const lang = !lang_private_close&&lang_private || sessionStorage.getItem("lang") || "zh-CN,zh";
  return {
    headers: {
      ...headers,
      "Accept-Language":  lang + ";q=0.9",
      ...getTeamRequestHeaders(variables),
    }
  };
});
 
// 创建 Apollo Client
const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache()
});
export default client
